/**
 * Drivers API Endpoints
 * Centralized endpoint definitions for driver operations.
 */
export const DRIVERS_ENDPOINTS = {
  /**
   * Get all supported drivers
   * @method GET
   * @endpoint /drivers
   */
  DRIVERS: "/drivers",
} as const;
